<template>
  <div class="material-manage-filter">
    <div>
      <el-input
        placeholder="请输入名称/素材ID"
        suffix-icon="el-icon-search"
        class="filter"
        v-model="formState.key"
        @change="handlesubmit"
      ></el-input>
      <el-cascader
        @change="handlesubmit"
        class="filter"
        style="width: 350px"
        placeholder="选择标签"
        v-model="formState.tag"
        :options="tagList"
        collapse-tags
        clearable
        :props="{ multiple: true, value: 'id', label: 'tagName', emitPath: false }"
        filterable
      ></el-cascader>
      <el-select v-model="formState.direction" placeholder="选择类型" multiple class="filter" @change="handlesubmit">
        <el-option v-for="item in directionList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
      </el-select>
      <el-select
        v-model="formState.resolution"
        placeholder="选择尺寸"
        multiple
        collapse-tags
        class="filter"
        @change="handlesubmit"
        filterable
      >
        <el-option v-for="item in resolutionList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
      </el-select>
      <el-select
        v-model="formState.designer"
        placeholder="选择设计"
        multiple
        collapse-tags
        filterable
        class="filter"
        @change="handlesubmit"
      >
        <el-option v-for="item in designerList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
      </el-select>
      <el-select
        v-model="formState.demander"
        placeholder="选择后期"
        multiple
        collapse-tags
        filterable
        class="filter"
        @change="handlesubmit"
      >
        <el-option v-for="item in demanderList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
      </el-select>
    </div>
    <div class="type">
      <el-radio-group v-model="formState.type" size="small" @change="handlesubmit">
        <el-radio-button label="全部" class="type-radio"></el-radio-button>
        <el-radio-button label="视频" class="type-radio"></el-radio-button>
        <el-radio-button label="图片" class="type-radio"></el-radio-button>
      </el-radio-group>
    </div>
  </div>
</template>

<script>
import { getTagRuleList, getTagPropertySelectList } from "@/api/property";

export default {
  data() {
    return {
      formState: {
        key: null, //关键字
        resolution: [], // 分辨率
        direction: [], //素材 版型
        designer: [], // 制作人
        tag: [],
        type: "全部", // video image
        pageSize: 10,
        pageIndex: 1,
        demander: [],
        // creativeSource: [],
      },
      tagList: [],
      directionList: [],
      resolutionList: [],
      designerList: [],
      demanderList: [],
    };
  },
  mounted() {
    this.getTags();
    this.getResolution();
    this.getDesigner();
  },
  methods: {
    getTags() {
      getTagRuleList().then((res) => {
        this.tagList = res.data;
      });
    },
    getResolution() {
      getTagPropertySelectList({ type: 2 }).then((res) => {
        this.resolutionList = res.data;
      });
      getTagPropertySelectList({ type: 1 }).then((res) => {
        this.directionList = res.data;
      });
    },
    getDesigner() {
      getTagPropertySelectList({ type: 4 }).then((res) => {
        this.designerList = res.data;
      });
      getTagPropertySelectList({ type: 5 }).then((res) => {
        this.demanderList = res.data;
      });
    },
    handlesubmit() {
      this.formState.pageIndex = 1;
      this.$emit("saveFilterParams", this.formState);
    },
  },
};
</script>
<style lang="less" scoped>
.material-manage-filter {
  .filter {
    width: 230px;
    margin-right: 24px;
    margin-top: 8px;
    /deep/ .el-input__inner {
      height: 32px !important;
    }
    /deep/ .el-cascader__search-input {
      min-width: 15px;
    }
    /deep/ .el-tag {
      max-width: 210px;
    }
  }
}
</style>
<style lang="less">
.material-manage-filter {
  .type {
    margin: 12px 0;
    .type-radio {
      .el-radio-button__inner {
        width: 88px;
      }
    }
  }
}
</style>
